import React, { useRef, useState, useEffect, useContext } from "react";
import Space from "antd/es/space";
import Input from "antd/es/input";
import Alert from "antd/es/alert";
import { UserOutlined, LockOutlined } from "@ant-design/icons";
import { TipsContext } from "@/context/Tips";
import { updateAdmin } from "@/server/adminManager";
import "./index.less";

export default function ManagerAccount() {
  const [showError, setShowError] = useState(false);
  const [errorMsg, setErrorMsg] = useState("账号或密码不能为空");
  const { useMessage } = useContext(TipsContext);

  const account = useRef("");
  const password = useRef("");
  useEffect(() => {
    // getAdmin()
  }, []);
  return (
    <div className="manager-account-wrap items-center justify-center">
      <Space direction="vertical" size={28}>
        <Input
          style={{ borderRadius: 2 }}
          placeholder="请输入账号"
          prefix={<UserOutlined style={{ color: "#1890FF" }} />}
          onChange={(e) => {
            account.current = e.target.value;
          }}
        />
        <Input.Password
          style={{ borderRadius: 2 }}
          placeholder="请输入密码"
          prefix={<LockOutlined style={{ color: "#1890FF" }} />}
          onChange={(e) => {
            password.current = e.target.value;
          }}
        />
        <Space direction="vertical" size={22}>
          {showError && (
            <Alert
              message={errorMsg}
              type="error"
              showIcon={true}
              style={{
                color: "#ff2e2e",
              }}
            />
          )}
          <div
            className="submit"
            onClick={() => {
              if (account.current === "" || password.current === "") {
                useMessage.error("账号或密码不能为空");
              } else {
                updateAdmin({
                  account: account.current,
                  password: password.current,
                }).then(
                  () => {
                    useMessage.success("修改成功");
                  },
                  () => {
                    useMessage.error("修改失败");
                  }
                );
              }
            }}
          >
            修改
          </div>
        </Space>
      </Space>
    </div>
  );
}
